import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { SERVICES } from "../lib/content";
import { ArrowUpRight } from "lucide-react";

export const Services = ({ onBook }) => {
  return (
    <section
      id="services"
      data-testid="services"
      className="py-24 lg:py-32 bg-brand-cream"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="max-w-3xl">
            <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-5">
              What we do
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-brand-ink leading-[1] tracking-tight">
              Five ways we stand in for you,
              <span className="italic text-brand"> in Jaipur</span>.
            </h2>
          </div>
        </Reveal>

        {/* Bento grid */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-6 gap-5 auto-rows-[minmax(0,1fr)]">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            // asymmetric spans
            const spanClass = [
              "md:col-span-4",
              "md:col-span-2",
              "md:col-span-3",
              "md:col-span-3",
              "md:col-span-2",
              "md:col-span-4",
              "md:col-span-6",
            ][i] || "md:col-span-2";
            const withImage = i === 0 || i === 4;
            return (
              <Reveal key={s.id} delay={i * 0.08} className={spanClass}>
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                  data-testid={`service-card-${s.id}`}
                  className={`group relative h-full min-h-[280px] rounded-3xl overflow-hidden border border-border ${
                    withImage ? "text-white" : "bg-white text-brand-ink"
                  }`}
                >
                  {withImage && (
                    <>
                      <img
                        src={s.image}
                        alt={s.title}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/85 via-brand-ink/30 to-transparent" />
                    </>
                  )}
                  <div className="relative h-full p-7 flex flex-col justify-between">
                    <div className="flex items-center justify-between">
                      <span
                        className={`inline-flex h-12 w-12 items-center justify-center rounded-full ${
                          withImage ? "bg-white/20 backdrop-blur" : "bg-brand-sand"
                        }`}
                      >
                        <Icon
                          size={22}
                          className={withImage ? "text-white" : "text-brand"}
                        />
                      </span>
                      <ArrowUpRight
                        size={22}
                        className={`opacity-0 group-hover:opacity-100 transition-opacity ${
                          withImage ? "text-white" : "text-brand"
                        }`}
                      />
                    </div>
                    <div className="mt-8">
                      <p
                        className={`text-xs font-semibold tracking-widest uppercase mb-3 ${
                          withImage ? "text-white/70" : "text-brand"
                        }`}
                      >
                        {s.label}
                      </p>
                      <h3 className="font-serif text-2xl sm:text-3xl leading-tight mb-3">
                        {s.title}
                      </h3>
                      <p
                        className={`text-sm leading-relaxed ${
                          withImage ? "text-white/80" : "text-brand-ink/70"
                        }`}
                      >
                        {s.desc}
                      </p>
                    </div>
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <button
            data-testid="services-book-btn"
            onClick={onBook}
            className="mt-12 inline-flex items-center gap-2 text-base font-medium text-brand-ink hover:text-brand transition-colors"
          >
            <span className="border-b border-brand-ink/30 pb-0.5">
              Book any of these for your parents
            </span>
            <ArrowUpRight size={18} />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
